export function SystemStatus() {
  return (
    <div className="bg-black bg-opacity-[0.03] items-center rounded-lg inline-flex gap-3 text-sm py-2 px-4">
      <div className="w-2 h-2 rounded-full bg-landing-page-green ring-landing-page-green ring ring-opacity-50"></div>
      System Status: OK
    </div>
  );
}
